export const EMPLOYEE_FORM_NAME = 'employee';



// WEBPACK FOOTER //
// ./src/modules/EmployeeForm/constants.js